import { Color, SRGBColorSpace } from "three";
import * as Maths from "oc-commons/Maths";

export function setTentantStyle(settings: any) {
  const tenant = settings.tenant;
  const style = document.createElement("style");

  const [primary, interactive, warning, error, leerraum] = [
    "PrimaryColor",
    "InteractiveColor",
    "WarningColor",
    "ErrorColor",
    "LeerraumColor",
  ].map((key) => new Color(tenant[key]));
  const focus = new Color(Commons.isEmpty(tenant["FocusColor"]) ? "#3c83f6" : tenant["FocusColor"]);
  const hover = new Color(
    Commons.isEmpty(tenant["PartHoverColor"]) ? "#3c83f6" : tenant["PartHoverColor"]
  );

  const hsl = (color: Color) => color.getHSL({} as any, SRGBColorSpace);

  const hsla = (color: Color, alpha = 1) => {
    const { h, s, l } = hsl(color);
    return `hsla(${Maths.round(h * 360, 1)},${Maths.round(s * 100, 1)}%,${Maths.round(
      l * 100,
      1
    )}%,${Maths.round(alpha, 2)})`;
  };
  const lMul = (color: Color, f: number) => {
    const { h, s, l } = hsl(color);
    const l2 = Math.max(0, Math.min(f * l, 1));
    return new Color().setHSL(h, s, l2, SRGBColorSpace);
  };
  const lRange = (color, lMin, lMax) => (lerp) =>
    lMul(color, lMin).lerpHSL(lMul(color, lMax), lerp);

  const [primaryRange, interactiveRange] = [primary, interactive].map((color) =>
    lRange(color, 0.75, 1.25)
  );

  style.innerHTML = `
:root {

  --color-primary-0: ${hsla(primaryRange(0))};
  --color-primary-1: ${hsla(primaryRange(0.25))};
  --color-primary-2: ${hsla(primaryRange(0.5))}; /* main color */
  --color-primary-3: ${hsla(primaryRange(0.75))};
  --color-primary-4: ${hsla(primaryRange(1))};

  --color-text-over-primary: ${
    hsl(primaryRange(0.5)).l > 0.6 ? "var(--color-dark-0)" : "var(--color-white)"
  };

  --color-interactive-0: ${hsla(interactiveRange(0))};
  --color-interactive-1: ${hsla(interactiveRange(0.75))};
  --color-interactive-2: ${hsla(interactiveRange(0.5))}; /* main color */
  --color-interactive-2-trans: ${hsla(interactiveRange(0.5), 0.7)};
  --color-interactive-3: ${hsla(interactiveRange(0.75))};
  --color-interactive-4: ${hsla(interactiveRange(1))};
  --color-interactive-4-trans: ${hsla(interactiveRange(1), 0.3)};

  --color-warning: ${hsla(warning)};
  --color-error: ${hsla(error)};

  --color-leerraum: ${hsla(leerraum)};
  --color-focus: ${hsla(focus)};
  --color-part-hover: ${hsla(hover)};
}

.assistant-avatar {
    background-image: url(${
      settings.wkfgContentBaseUrl + "/Tenant/" + APP.settings.tenant?.Assistant
    });
}
`;
  document.head.appendChild(style);
}
